import React from 'react';
import LoadingSvg from '../../../includes/img/svg/loading.svg';
import LoadingTextSvg from '../../../includes/img/svg/text.svg';
import Modal from "react-modal";
import './styles.scss';

const ProcessLoaderForLoading = ({ isShown }) => {
    if (isShown) {
        return (
            <Modal
                ariaHideApp={false}
                isOpen={isShown}
                className="loader-modal"
                overlayClassName="loader-modal-overlay"
            >
                <img src={LoadingSvg} alt="" className="loader-icon" />
                <img src={LoadingTextSvg} alt="GE" className="loader-text" />
            </Modal>
        );
    } else {
        return "";
    }
};

export default ProcessLoaderForLoading;
